import PropTypes from 'prop-types';
import React from 'react';
import { analyticsListeners } from '~/analytics';
import { Media } from '~/components';
import { TimeSlotsSections } from './time-slots-sections';
import styles from './TimeSlots.scss';

export class TimeSlots extends React.PureComponent {
  selectMainAppointmentTimeSlot = (selectedTimeSlot) => {
    const { isEditMode, dispatchSetMainAppointmentTimeSlot } = this.props;
    dispatchSetMainAppointmentTimeSlot(selectedTimeSlot);

    if (isEditMode) {
      analyticsListeners.triggerEditPageChangesMadeAnalytics(
        'appointments',
        'appointments:date/time',
      );
    } else {
      analyticsListeners.triggerSelectTimeSlotAnalytics();
    }
  };

  selectRelatedAppointmentTimeSlot = (selectedTimeSlot) => {
    const { dispatchSetRelatedAppointmentTimeSlot } = this.props;

    dispatchSetRelatedAppointmentTimeSlot(selectedTimeSlot);
  };

  shouldDisableMainTreatmentSlot = (slot) => {
    const { relatedAppointmentType } = this.props;
    return (
      relatedAppointmentType &&
      (slot.to >= relatedAppointmentType.slots[relatedAppointmentType.slots.length - 1].from ||
        (relatedAppointmentType.selectedTimeSlot.from &&
          slot.to >= relatedAppointmentType.selectedTimeSlot.from))
    );
  };

  shouldDisableRelatedTreatmentSlot = (slot) => {
    const { mainAppointmentType } = this.props;
    return (
      slot.from <= mainAppointmentType.slots[0].to ||
      slot.from <= mainAppointmentType.selectedTimeSlot.to
    );
  };

  render() {
    const {
      timeSlotsList: TimeSlotsComponent,
      areSlotsEqual,
      mainAppointmentType,
      relatedAppointmentType,

      timeSlotSectionTitle,
      formatSlots,
      children,
    } = this.props;

    return (
      <Media>
        {({ screenWidth }) => {
          const isMobile = Media.lessThan(screenWidth, Media.BREAKPOINTS.XS);
          const relatedSelectedTimeSlot =
            relatedAppointmentType && relatedAppointmentType.selectedTimeSlot;
          const relatedSelectedTimeSlotStartTime =
            relatedSelectedTimeSlot && relatedSelectedTimeSlot.from;

          return (
            <section className={styles.Appointment_time} data-testid="time">
              <p id="time-slot-title" className={styles.Appointment_time_title}>
                {timeSlotSectionTitle || 'Choose a time slot'}
              </p>
              {children}
              <div className={styles.TimeSlotsSection}>
                <div className={styles.TimeSlotSection}>
                  <TimeSlotsComponent
                    timeSlotAccordionTitle={mainAppointmentType.timeSlotAccordionTitle}
                    appointmentType={mainAppointmentType.appointmentType}
                    slots={mainAppointmentType.slots}
                    shouldDisableSlot={this.shouldDisableMainTreatmentSlot}
                    selectedTimeSlot={mainAppointmentType.selectedTimeSlot}
                    selectTimeSlot={this.selectMainAppointmentTimeSlot}
                    formatSlots={formatSlots}
                    shouldCollapse={(hasSelectedSlot) =>
                      !!(hasSelectedSlot && relatedSelectedTimeSlot)
                    }
                    shouldBeClosed={isMobile && mainAppointmentType.selectedTimeSlot.from === 0}
                    hasSelectedRelatedTimeSlot={relatedSelectedTimeSlotStartTime > 0}
                    timeSlotTooltipText="This slot cannot be selected as this treatment needs to be before the next"
                    areSlotsEqual={areSlotsEqual}
                  />
                </div>
                {relatedAppointmentType && (
                  <div className={styles.TimeSlotSection}>
                    <TimeSlotsComponent
                      timeSlotAccordionTitle={relatedAppointmentType.timeSlotAccordionTitle}
                      appointmentType={relatedAppointmentType.appointmentType}
                      slots={relatedAppointmentType.slots}
                      shouldDisableSlot={this.shouldDisableRelatedTreatmentSlot}
                      selectedTimeSlot={relatedAppointmentType.selectedTimeSlot}
                      selectTimeSlot={this.selectRelatedAppointmentTimeSlot}
                      formatSlots={formatSlots}
                      shouldCollapse={(hasSelectedSlot) => hasSelectedSlot}
                      shouldBeClosed={isMobile && relatedSelectedTimeSlotStartTime === 0}
                      timeSlotTooltipText="This slot cannot be selected as this treatment needs to be after the previous"
                    />
                  </div>
                )}
              </div>
            </section>
          );
        }}
      </Media>
    );
  }
}

TimeSlots.propTypes = {
  mainAppointmentType: PropTypes.shape({
    selectedTimeSlot: PropTypes.shape({
      from: PropTypes.number.isRequired,
      to: PropTypes.number,
    }).isRequired,
  }).isRequired,
  relatedAppointmentType: PropTypes.shape({
    selectedTimeSlot: PropTypes.shape({
      from: PropTypes.number.isRequired,
      to: PropTypes.number,
    }).isRequired,
  }),
  isEditMode: PropTypes.bool,
  children: PropTypes.node,
  timeSlotsList: PropTypes.func,
  timeSlotSectionTitle: PropTypes.string,
  formatSlots: PropTypes.func,
  areSlotsEqual: PropTypes.func,

  dispatchSetMainAppointmentTimeSlot: PropTypes.func.isRequired,
  dispatchSetRelatedAppointmentTimeSlot: PropTypes.func.isRequired,
};

TimeSlots.defaultProps = {
  children: [],
  timeSlotsList: TimeSlotsSections,
  timeSlotSectionTitle: null,
  formatSlots: undefined,
  relatedAppointmentType: null,
  isEditMode: false,
  areSlotsEqual: undefined,
};
